<template>
<div>
    <div class="float-lg-right mb-3">
        <download-excel :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="couponList.xls">Excel
        </download-excel>
    </div>
    <b-table-simple head-variant="light" class="vuetable" responsive>
        <b-thead head-variant="light">
            <b-tr>
                <template v-for="(field , idx) in fields">
                    <b-th style="text-align: center" :key="idx" :rowspan="idx <= 2 ? '2' : 0" v-if="idx <= 2">{{ field.label }}</b-th>
                    <b-th style="text-align: center" :key="idx" :colspan="idx === 3 ? '5' : '0'" v-if="idx === 3">{{ field.label }}</b-th>
                    <b-th style="text-align: center" :key="idx" :colspan="idx === 4 ? '4' : '0'" v-if="idx === 4">{{ field.label }}</b-th>
                    <b-th style="text-align: center" :key="idx" :colspan="idx === 5 ? '2' : '0'" v-if="idx === 5">{{ field.label }}</b-th>
                </template>
            </b-tr>
            <b-tr>
                <template v-for="(field , idx) in fields">
                    <b-th style="text-align: center" :key="idx" v-if="idx > 5">{{ field.label }}</b-th>
                </template>
            </b-tr>
        </b-thead>
        <b-tbody>
            <template v-for="(item , i ) in goodsData">

                <b-tr :key="i">
                    <!-- <b-td>{{ item }}</b-td> -->
                    <b-td style="text-align:center">{{ goodsTypeVal(item.goodsType) }}</b-td>
                    <b-td style="text-align:center">{{ item.goodsName }}</b-td>
                    <b-td style="text-align:center">{{ item.optionName }}</b-td>
                    <b-td style="text-align:center">{{ item.count | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.originalSalesAmountTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.salePrice | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.salesDeliveryAmountTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.commission | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.penaltyCount | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.penaltyTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.penaltyDeliveryAmountTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.penaltyCommissionTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.netPrice | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.commissionTotal | currency }}</b-td>
                </b-tr>

            </template>

            <template>
                <b-tr>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important;">합계</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important;"></b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important;"></b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('count')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('originalSalesAmountTotal')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('salePrice')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('salesDeliveryAmountTotal')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('commission')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ penaltyCountN() }}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('penaltyTotal')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('penaltyDeliveryAmountTotal')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('penaltyCommissionTotal')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('netPrice')}}</b-td>
                    <b-td style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('commissionTotal')}}</b-td>
                </b-tr>
            </template>
        </b-tbody>
    </b-table-simple>
    <!--    <b-pagination size="sm"-->
    <!--                  align="center"-->
    <!--                  :total-rows="total"-->
    <!--                  :per-page="perPage"-->
    <!--                  v-model="currentPage"-->
    <!--    >-->
    <!--      <template v-slot:next-text>-->
    <!--        <i class="simple-icon-arrow-right"/>-->
    <!--      </template>-->
    <!--      <template v-slot:prev-text>-->
    <!--        <i class="simple-icon-arrow-left"/>-->
    <!--      </template>-->
    <!--      <template v-slot:first-text>-->
    <!--        <i class="simple-icon-control-start"/>-->
    <!--      </template>-->
    <!--      <template v-slot:last-text>-->
    <!--        <i class="simple-icon-control-end"/>-->
    <!--      </template>-->
    <!--    </b-pagination>-->

</div>
</template>

<script>
import {
    mapGetters,
} from "vuex";
import {
    alignTableCenter,
    currencyFilter,
    getGoodsTypeStr,
} from "../../../utils";

export default {
    components: {},
    props: ['data'],
    filters: {
        ...currencyFilter
    },
    data() {
        return {
            total: 0,
            currentPage: 1,
            perPage: 10,
            item: null,
            searchDate: null,
            goodsType: null,
            couponList: [],
            goodsData: [],
            fields: [{
                    key: "goodsType",
                    label: "상품구분",
                    ...alignTableCenter
                },
                {
                    key: "goodsName",
                    label: "상품명",
                    ...alignTableCenter
                },
                {
                    key: "optionName",
                    label: "옵션명",
                    ...alignTableCenter
                },
                {
                    key: "salesFormUse",
                    label: "사용매출",
                    ...alignTableCenter
                },
                {
                    key: "cancelFeeSales",
                    label: "위약금 매출",
                    ...alignTableCenter
                },
                {
                    key: "commission",
                    label: "합계",
                    ...alignTableCenter
                },
                {
                    key: "transactionCount",
                    label: "건수",
                    ...alignTableCenter
                },
                {
                    key: "originalSalesAmountTotal",
                    label: "판매가",
                    ...alignTableCenter
                },
                {
                    key: "salePrice",
                    label: "실판매가",
                    ...alignTableCenter
                },
                {
                    key: "salesDeliveryAmountTotal",
                    label: "입금액",
                    ...alignTableCenter
                },
                {
                    key: "salesCommissionTotal",
                    label: "수수료",
                    ...alignTableCenter
                },
                {
                    key: "penaltyCount",
                    label: "건수",
                    ...alignTableCenter
                },
                {
                    key: "penaltyTotal",
                    label: "위약금",
                    ...alignTableCenter
                },
                {
                    key: "penaltyDeliveryAmountTotal",
                    label: "위약금입금액",
                    ...alignTableCenter
                },
                {
                    key: "penaltyCommissionTotal",
                    label: "위약금수수료",
                    ...alignTableCenter
                },
                {
                    key: "deliveryAmountTotal",
                    label: "총입금액",
                    ...alignTableCenter
                },
                {
                    key: "commissionTotal",
                    label: "총수수료",
                    ...alignTableCenter
                },
                // {key: "netPrice", label: "입금액", ...alignTableCenter},
            ],
            json_fields: {
                '상품구분': 'goodsType',
                '상품명': 'goodsName',
                '옵션명': 'optionName',
                '건수': 'count',
                '판매가': 'originalSalesAmountTotal',
                '실판매가': 'salePrice',
                '입금액': 'netPrice',
                '수수료': 'commission',
                '취소건수': 'penaltyCount',
                '위약금': 'penaltyTotal',
                '위약금입금액': 'penaltyDeliveryAmountTotal',
                '위약금수수료': 'penaltyCommissionTotal',
                '총입금액': 'deliveryAmountTotal',
                '총수수료': 'commissionTotal',

            },
            json_meta: [
                [{
                    'key': 'charset',
                    'value': 'utf-8'
                }]
            ],
            excelData: []
        }
    },
    computed: {},
    mounted() {},
    methods: {
        goodsTypeVal(val) {
            return getGoodsTypeStr(val);
        },
        penaltyCountN(){
            let penaltyCount = 0;
            this.goodsData.forEach((el) => {
                if(el.penaltyCount !== NaN){
                    penaltyCount += Number(el.penaltyCount);
                }
            });
            return penaltyCount ;
        },
        totalData(data) {
            let count = 0,
                originalSalesAmountTotal = 0,
                salePrice = 0,
                salesDeliveryAmountTotal = 0,
                commission = 0,
                penaltyTotal = 0,
                penaltyDeliveryAmountTotal = 0,
                penaltyCommissionTotal = 0,
                netPrice = 0,
                commissionTotal = 0;
            this.goodsData.forEach((el) => {
                count += Number(el.count);
                originalSalesAmountTotal += Number(el.originalSalesAmountTotal);
                salePrice += Number(el.salePrice);
                salesDeliveryAmountTotal += Number(el.salesDeliveryAmountTotal);
                commission += Number(el.commission);
                penaltyTotal += Number(el.penaltyTotal);
                penaltyDeliveryAmountTotal += Number(el.penaltyDeliveryAmountTotal);
                penaltyCommissionTotal += Number(el.penaltyCommissionTotal);
                netPrice += Number(el.netPrice);
                commissionTotal += Number(el.commissionTotal);
            });
            if (data == "count") {
                return count;
            } else if (data == "originalSalesAmountTotal") {
                return originalSalesAmountTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "salePrice") {
                return salePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "salesDeliveryAmountTotal") {
                return salesDeliveryAmountTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "commission") {
                return commission.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }  else if (data == "penaltyTotal") {
                return penaltyTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "penaltyDeliveryAmountTotal") {
                return penaltyDeliveryAmountTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "penaltyCommissionTotal") {
                return penaltyCommissionTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "netPrice") {
                return netPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (data == "commissionTotal") {
                return commissionTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

        },
        init(date, goodsType, item) {
            this.searchDate = date
            this.goodsType = goodsType
            this.item = item
            this.loadData()
        },

        loadData() {

            /**
             * 1. 특정날짜, 특정상품유형
             * 2. 모든날짜, 특정상품유형(하단합계)
             * 3. 특정날짜, 모든상품유형
             * 4. 모든날짜, 모든상품유형(우측합계)
             */
            const vm = this
            this.couponList = []
            this.goodsData = []

            if (this.searchDate == null) { //모든날짜

                this.item.forEach(function (v, index) {

                    //goodsType : Booking, BookingCoupon, MobileCoupon, Summary(정산현황), null(매출현황)
                    if (vm.goodsType == null) {
                        v.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.BookingCoupon != null && (vm.goodsType == "BookingCoupon" || vm.goodsType == "Summary")) {
                        v.BookingCoupon.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.MobileCoupon != null && (vm.goodsType == "MobileCoupon" || vm.goodsType == "Summary")) {
                        v.MobileCoupon.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.MoneyCoupon != null && (vm.goodsType == "MoneyCoupon" || vm.goodsType == "Summary")) {
                        v.MoneyCoupon.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.StoreBooking != null && (vm.goodsType == "StoreBooking" || vm.goodsType == "Summary")) {
                        v.StoreBooking.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }
                })

            } else { //특정날짜

                if (this.item.BookingCoupon != null && (this.goodsType == "BookingCoupon" || this.goodsType == "Summary")) {
                    this.item.BookingCoupon.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }

                if (this.item.MobileCoupon != null && (this.goodsType == "MobileCoupon" || this.goodsType == "Summary")) {
                    this.item.MobileCoupon.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }

                if (this.item.MoneyCoupon != null && (this.goodsType == "MoneyCoupon" || this.goodsType == "Summary")) {
                    this.item.MoneyCoupon.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }

                if (this.item.StoreBooking != null && (this.goodsType == "StoreBooking" || this.goodsType == "Summary")) {
                    this.item.StoreBooking.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }
            }

            // console.log("couponList", vm.couponList);

            this.couponList.forEach((v) => {
                v.options.forEach((vv) => {

                    if (vm.goodsData.length > 0) {
                        let flag = false;
                        let flagNum = null;
                        vm.goodsData.forEach((vvv, idx) => {
                            if (v.goodsName == vvv.goodsName && vv.optionName == vvv.optionName) {
                                flag = true;
                                flagNum = idx;
                            }
                        })

                        if (flag) {
                            vm.goodsData[flagNum].count = Number(vm.goodsData[flagNum].count) + Number(vv.transactionCount)
                            vm.goodsData[flagNum].salePrice = Number(vm.goodsData[flagNum].salePrice) + Number(vv.salesAmountTotal)
                            vm.goodsData[flagNum].commission = Number(vm.goodsData[flagNum].commission) + Number(vv.salesCommissionTotal)
                            vm.goodsData[flagNum].netPrice = Number(vm.goodsData[flagNum].netPrice) + Number(vv.deliveryAmountTotal)
                            vm.goodsData[flagNum].salesDeliveryAmountTotal = Number(vm.goodsData[flagNum].salesDeliveryAmountTotal) + Number(vv.salesDeliveryAmountTotal)
                            vm.goodsData[flagNum].originalSalesAmountTotal = Number(vm.goodsData[flagNum].originalSalesAmountTotal) + Number(vv.originalSalesAmountTotal)
                            vm.goodsData[flagNum].penaltyTotal = Number(vm.goodsData[flagNum].penaltyTotal) + Number(vv.penaltyTotal)
                            vm.goodsData[flagNum].penaltyDeliveryAmountTotal = Number(vm.goodsData[flagNum].penaltyDeliveryAmountTotal) + Number(vv.penaltyDeliveryAmountTotal)
                            vm.goodsData[flagNum].penaltyCommissionTotal = Number(vm.goodsData[flagNum].penaltyCommissionTotal) + Number(vv.penaltyCommissionTotal)
                            vm.goodsData[flagNum].commissionTotal = Number(vm.goodsData[flagNum].commissionTotal) + Number(vv.commissionTotal)
                            vm.goodsData[flagNum].penaltyCount = Number(vm.goodsData[flagNum].penaltyCount) + Number(vv.penaltyCount)

                        } else {
                            // let selseAt = 0;
                            // if (v.goodsType === 'StoreBooking') {
                            //     selseAt = vv.originalSalesAmountTotal - vv.discountAmountTotal;
                            // } else {
                            //     selseAt = vv.salesAmountTotal;
                            // }
                            vm.goodsData.push({
                                'goodsType': v.goodsType,
                                'goodsName': v.goodsName,
                                'optionName': vv.optionName,
                                'count': vv.transactionCount,
                                'originalSalesAmountTotal': vv.originalSalesAmountTotal,
                                'salePrice': vv.salesAmountTotal,
                                'salesDeliveryAmountTotal': vv.salesDeliveryAmountTotal,
                                'commission': vv.salesCommissionTotal,
                                'penaltyTotal': vv.penaltyTotal,
                                'penaltyDeliveryAmountTotal': vv.penaltyDeliveryAmountTotal,
                                'penaltyCommissionTotal': vv.penaltyCommissionTotal,
                                'netPrice': vv.deliveryAmountTotal,
                                'commissionTotal': vv.commissionTotal,
                                'penaltyCount': vv.penaltyCount,
                            })

                            // console.log(vm.goodsData)

                        }
                    } else {
                        // console.log("push");
                        let selseAt = 0;
                        if (v.goodsType === 'StoreBooking') {
                            // selseAt = vv.originalSalesAmountTotal - vv.discountAmountTotal;
                            selseAt = vv.salesAmountTotal;
                        } else {
                            selseAt = vv.salesAmountTotal;
                        }
                        vm.goodsData.push({
                            'goodsType': v.goodsType,
                            'goodsName': v.goodsName,
                            'optionName': vv.optionName,
                            'count': vv.transactionCount,
                            'originalSalesAmountTotal': vv.originalSalesAmountTotal,
                            'salePrice': selseAt,
                            'salesDeliveryAmountTotal': vv.salesDeliveryAmountTotal,
                            'commission': vv.salesCommissionTotal,
                            'penaltyTotal': vv.penaltyTotal,
                            'penaltyCount': vv.penaltyCount,
                            'penaltyDeliveryAmountTotal': vv.penaltyDeliveryAmountTotal,
                            'penaltyCommissionTotal': vv.penaltyCommissionTotal,
                            'netPrice': vv.deliveryAmountTotal,
                            'commissionTotal': vv.commissionTotal,
                        })
                    }

                })
            })

            // console.log(this.couponList);

            vm.goodsData.sort(function (a, b) {
                return a.goodsName < b.goodsName ? 1 : -1;
            });

        },
        async fetchData() {

            this.excelData = [];
            this.goodsData.forEach((v) => {
                this.excelData.push({
                    'goodsType': this.goodsTypeVal(v.goodsType),
                    'goodsName': v.goodsName,
                    'optionName': v.optionName,
                    'count': v.count,
                    'originalSalesAmountTotal': v.originalSalesAmountTotal,
                    'salePrice': v.salePrice,
                    'netPrice': v.netPrice,
                    'commission': v.commission,
                    'penaltyCount': v.penaltyCount,
                    'penaltyTotal': v.penaltyTotal,
                    'penaltyDeliveryAmountTotal': v.penaltyDeliveryAmountTotal,
                    'penaltyCommissionTotal': v.penaltyCommissionTotal,
                    'deliveryAmountTotal': v.netPrice,
                    'commissionTotal': v.commissionTotal,

                })
            })
            return this.excelData
        }
    }
}
</script>

<style scoped>
.table .thead-light th {
    border: 1px solid #fff !important;
    vertical-align: middle;
}
</style>
